import styled from '@emotion/styled';
import { Spacings, mediaQuery } from '@styles/index';
import AllAboutExam from '@cont/NewPreSubscribed/AllAboutExam';
import PropTypes from 'prop-types';
import NewFooter from '@layout/Footer/NewFooter';
import { usePageSeoContent } from '@stores/AppCommonData';
import useOfflineCentreStore from '@stores/city-specific-offline-centres';

import Header from './Header';

const Container = styled.div`
  min-height: 100vh;
  background-color: ${({ backgroundColor }) =>
    backgroundColor || 'var(--color-base-1)'};
  margin: auto;
  position: relative;
  display: flex;
  flex-direction: column;
`;

const StyHeader = styled(Header)``;

const FooterWrapper = styled.div`
  margin-bottom: ${Spacings.SPACING_16B};
  /* overflow: hidden; */
`;

const OfflineCentreContainer = styled.div`
  width: 100%;
  position: relative;
  margin-top: ${Spacings.SPACING_18B};
  display: flex;
  flex-direction: column;
  min-height: ${({ $isFooterHidden }) => ` calc(
    100vh -
      ${
        Spacings.SPACING_HEADER +
        Spacings.SPACING_HEADER_MARGIN +
        ($isFooterHidden
          ? 0
          : Spacings.SPACING_FOOTER + Spacings.SPACING_FOOTER_MARGIN + 12)
      }px
  )`};

  ${mediaQuery.uptoMobile} {
    width: 100%;
    margin-top: ${Spacings.SPACING_16B};
  }
  & > .aquilla-overlay {
    z-index: 3500;
  }
`;

const Wrapper = styled.div`
  grid-column: span 24;
  width: 100%;
  padding-bottom: ${Spacings.SPACING_4B};
  background-color: var(--color-base-0);
  border-top: ${Spacings.SPACING_1} solid var(--color-divider);
`;

const OfflineCentreLayout = ({ children, className }) => {
  const { contentBlock } = usePageSeoContent();
  const { centreData, isBookAVisitFlow } = useOfflineCentreStore();
  return (
    <>
      <Container>
        <StyHeader showLogin className={className} centreData={centreData} />
        <OfflineCentreContainer $isBookAVisitFlow={isBookAVisitFlow}>
          {children}
        </OfflineCentreContainer>
        {contentBlock?.id && (
          <Wrapper>
            <AllAboutExam />
          </Wrapper>
        )}

        <FooterWrapper>
          <NewFooter />
        </FooterWrapper>
      </Container>
    </>
  );
};

OfflineCentreLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  className: PropTypes.string
};

OfflineCentreLayout.defaultProps = {
  className: ''
};

export default OfflineCentreLayout;
